import { render, staticRenderFns } from "./TrueFalseOption.vue?vue&type=template&id=2f89aa71&"
import script from "./TrueFalseOption.vue?vue&type=script&lang=js&"
export * from "./TrueFalseOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports